// src/components/RefreshButton.tsx
import React from 'react';

interface RefreshButtonProps {
  onClick: () => void;
  isLoading: boolean;
  lastRefreshed: number;
  formatTimestamp: (timestamp: number) => string;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick,
  isLoading,
  lastRefreshed,
  formatTimestamp
}) => {
  return (
    <div className="flex items-center">
      {/* Last refreshed timestamp */}
      {lastRefreshed > 0 && (
        <span className="text-xs text-dashboard-text-muted-light dark:text-dashboard-text-muted-dark mr-3">
          Last updated: {formatTimestamp(lastRefreshed)}
        </span>
      )}
      
      {/* Refresh button */}
      <button
        onClick={onClick}
        disabled={isLoading}
        className={`flex items-center px-3 py-1.5 rounded-md transition-colors ${
          isLoading
            ? 'bg-gray-200 dark:bg-gray-700 cursor-not-allowed'
            : 'bg-ethereum hover:bg-ethereum-dark text-white hover:shadow-md'
        }`}
        title="Refresh data"
      >
        {isLoading ? (
          <>
            <div className="w-4 h-4 border-2 border-gray-400 dark:border-gray-500 border-t-transparent dark:border-t-transparent rounded-full animate-spin mr-2"></div>
            <span>Updating...</span>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            <span>Refresh</span>
          </>
        )}
      </button>
    </div>
  );
};

export default RefreshButton;
